module.exports = __webpack_public_path__ + "static/media/Rectangle 28.25d13384.png";